import React from 'react';
import Navbar from '../components/Navbar';
import FormContent from '../components/FormContent';
import Footer from '../components/Footer';

const Form = () => {
	return (
		<>
			<Navbar />
			<FormContent />
			<Footer />
		</>
	);
};

export default Form;
